import { useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import {
  Box,
  Stack,
  useDisclosure
} from '@chakra-ui/react'
import {
  authSelectors,
  handleOpenModal,
  markersSelectors,
  setBlogParent,
  setComments,
  setConnReqData,
  setHideNotification,
  setNotificationSectionPage,
  setOpenFriendRequest,
  setPosts,
  stopMap
} from 'store'
import {
  MODAL_SECTION,
  NotificationSections,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

import { NotifBarDisplay } from 'components/Footer/NotifBarDisplay'
import { NotificationDrawer } from './NotificationDrawer'

export const Footer = () => {
  const {
    mapStop,
    selectedMarkerData
  } = useSelector(markersSelectors)
  const { signInStatus } = useSelector(authSelectors)

  const { onOpen, isOpen, onClose } = useDisclosure()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [dynamicIsOpen, setDynamicIsOpen] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [localHidePanel, setLocalHidePanel] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const clearOptions = (isNotifModalOpen) => {
    if (isNotifModalOpen) {
      // If the marker popup is opened via the url,
      // this will ensure that the marker popup is closed
      // before opening the notification modal
      document.querySelector('div.leaflet-container').click()
    } else {
      dispatch(setOpenFriendRequest(null))
    }

    dispatch(setConnReqData([]))
    sessionStorage.removeItem('id')
    localStorage.removeItem('openedNotifId')
    localStorage.setItem('is-notif-modal-open', 'false')
    dispatch(handleOpenModal({ isOpen: isNotifModalOpen, section: MODAL_SECTION?.RightSection }))
    navigate('/')

    if (isNotifModalOpen) {
      const customPopupOverlay = document.querySelector('#custom-popup-overlay')
      const customPopupOverlayEvent = document.querySelector('#custom-popup-overlay-event')

      if (customPopupOverlay) {
        customPopupOverlay.click()
      } else if (customPopupOverlayEvent) {
        customPopupOverlayEvent.click()
      }
    }

    // The timeout is used to ensure other drawers/modals are closed before opening
    // Also used for the timing of fiter items' animation to left
    dispatch(setHideNotification(false))
    setRunClosingAnimation(!isNotifModalOpen)
    setTimeout(() => {
      setLocalHidePanel(!isNotifModalOpen)
      setTimeout(() => setDynamicIsOpen(isNotifModalOpen), isNotifModalOpen ? 0 : 50)

      setTimeout(() => {
        if (!isNotifModalOpen && document.querySelectorAll('.chakra-modal__content').length === 0) {
          showCoordParams(setSearchParams)
        }
      }, 200)
    }, isNotifModalOpen ? 200 : 1000)
  }

  return (
    <Stack
      position="relative"
      background={COLORS.gold}
      width="100%"
      height="50px"
      className="notificationBar"
      data-name="notificationBar"
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        cursor="pointer"
        id="open-notif-panel"
        onClick={() => {
          sessionStorage.removeItem('openProfileAfterAnimation')
          sessionStorage.removeItem('openEventAfterAnimation')

          if (
            !searchParams.get('id')
            && !searchParams.get('post-id')
            && !searchParams.get('eventid')
            && !selectedMarkerData
          ) {
            // This is to prevent profile card and chat modal being open at the same time
            document.querySelector('div.leaflet-container').click()
            dispatch(setNotificationSectionPage({
              key: NotificationSections.NOTIFICATIONS,
              title: 'Notifications'
            }))
            dispatch(stopMap(!mapStop))
            dispatch(setConnReqData([]))
            dispatch(setBlogParent([]))
            dispatch(setPosts([]))
            dispatch(setComments([]))
            localStorage.setItem('isNotifOpen', 'true')
            clearOptions(true)
            onOpen()
          }
        }}
      >
        {
          isAuth()
            ? <NotifBarDisplay dynamicIsOpen={dynamicIsOpen} />
            : (
              <Box
                height="40px"
                padding="10px 61px"
                borderRadius="5px"
                backgroundColor="white"
                width="366px"
                fontSize="20px"
                lineHeight="22.5px"
                boxShadow="0 3px 3px 0 rgba(108, 122, 137, .7)"
                sx={{
                  '@media (max-width: 768px)': {
                    width: '385px'
                  },
                  '@media (max-width: 480px)': {
                    width: '306px',
                    fontSize: '15px'
                  },
                  '@media (max-width: 390px)': {
                    width: '266px',
                    padding: '10px 45px',
                    fontSize: '15px'
                  }
                }}
              >
                <center>
                  {
                    sessionStorage.getItem('postId')
                    && signInStatus !== SUCCEEDED
                    && !isAuth()
                      ? 'Get Connected! Sign Up...'
                      : 'Instructions'
                  }
                </center>
              </Box>
            )
        }
      </Box>

      <NotificationDrawer
        dynamicIsOpen={dynamicIsOpen}
        runClosingAnimation={runClosingAnimation}
        localHidePanel={localHidePanel}
        setDynamicIsOpen={setDynamicIsOpen}
        clearOptions={clearOptions}
        onClose={onClose}
      />
    </Stack>
  )
}
